import { render, staticRenderFns } from "./TradeEvolution.vue?vue&type=template&id=6df9e81b&"
import script from "./TradeEvolution.vue?vue&type=script&lang=js&"
export * from "./TradeEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports